import SeekFormComp from "@Components/buyCarMenu/SeekFormComp";
import withLayout from "../../layouts/withLayout";
import React, { useMemo, useState } from "react";
import { Breadcrumb, Image } from "antd";
import { useQuery } from "react-query";
import { fetchMenuInit } from "@Services/buyCarMenu";
import qs from "qs";
import RollingText from "@Components/buyCarMenu/RollingText";
import { fetchRace } from "@Services/api";
import QRCode from "qrcode.react";
import seekFormImage from "../../static/common/seek-banner.png";
import { Status_3_Result, Status_2_Result, Status_4_Result } from "@Components/buyCarMenu/Result.tsx";

const breadcrumbCls = "text-[#333] text-14 font-normal";
const SeekFormPage = () => {
  const { id } = qs.parse(location.search, { ignoreQueryPrefix: true }) as { id: string };
  const [inquiryData, setInquiryData] = useState<any>({
    // status: 3,
    // content: "業代帳號無法提交徵求菜单",
  });

  const [kindid, setKindId] = useState("");

  const { data } = useQuery(["fetchMenuInit", id], async () => {
    const res = await fetchMenuInit({ id, type: "2" });

    if (res?.status === 12000) {
      return res.data;
    }
    return { menu: {}, options: {} };
  });

  const { data: carouselData = [] } = useQuery([`buyCarMenu`], async () => {
    const res = await fetchRace({ type: "buyCarMenuSeek" });
    return res?.data?.list || [];
  });

  const PageContainer = useMemo(() => {
    if (inquiryData?.status === 2) {
      return <Status_2_Result data={inquiryData} kindId={kindid} />;
    }
    if (inquiryData.status === 3) {
      return <Status_3_Result data={inquiryData} />;
    }
    const activityStatus = inquiryData?.activity?.activity;
    return (
      <div className='w-[1190px] relative flex justify-center items-center h-[330px] bg-[#fff] mb-40 gap-x-68'>
        <div className='flex'>
          <Image width={30} height={30} src='https://photo.8891.com.tw/2024/07/30/1722319909559963.png' />
          <div className='ml-14 flex flex-col text-18 leading-24 font-medium text-[#333]'>
            徵求菜單發佈成功
            <span className='text-14 text-[#666] font-normal'>{inquiryData?.content}</span>
          </div>
        </div>
        {!!activityStatus && (
          <div className={`w-[140px] h-[110px] flex flex-col items-center`}>
            <div className='w-80 h-80'>
              {inquiryData?.qrCodeUrl && (
                <QRCode
                  value={inquiryData?.qrCodeUrl}
                  size={80}
                  bgColor={"#ffffff"}
                  fgColor={"#000000"}
                  level={"L"}
                  includeMargin={false}
                />
              )}
            </div>
            <span className='text-14 text-[#666] leading-20'>行動掃碼查看菜單</span>
          </div>
        )}
      </div>
    );
  }, [inquiryData, inquiryData?.status]);

  return (
    <div className='w-screen bg-[#f5f5f5]'>
      <div className='w-[1190px] relative flex flex-col' style={{ margin: "0 auto" }}>
        <div className='h-[60px] flex items-center'>
          <Breadcrumb separator=''>
            <Breadcrumb.Item className={breadcrumbCls}>您當前的位置</Breadcrumb.Item>
            <Breadcrumb.Separator>:</Breadcrumb.Separator>
            <Breadcrumb.Item href='https://c.8891.com.tw/Models'>
              <span className={breadcrumbCls}>新車</span>
            </Breadcrumb.Item>
            <Breadcrumb.Separator> {">"} </Breadcrumb.Separator>
            <Breadcrumb.Item href='https://c.8891.com.tw/buycar/menu'>
              <span className={breadcrumbCls}> 購車菜單</span>
            </Breadcrumb.Item>
            <Breadcrumb.Separator> {">"} </Breadcrumb.Separator>
            <Breadcrumb.Item className={breadcrumbCls}>
              <span className={breadcrumbCls}>徵求菜單資料填寫</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <Status_4_Result
          visible={inquiryData?.status === 4}
          content={inquiryData?.content}
          onClose={() => {
            setInquiryData({});
          }}
        />
        {!!Object.keys(inquiryData).length ? (
          PageContainer
        ) : (
          <>
            <div className='w-[1190px] mb-20'>
              <RollingText
                data={carouselData}
                containerStyle={{ width: "100%", background: "#fff" }}
                customerText={(item) => (
                  <div>
                    {item.time}
                    {item.name}
                    {item.type}
                    {item.brandName}菜單
                  </div>
                )}
              />
            </div>
            <div
              className='w-[1190px] h-100 bg-no-repeat bg-contain cursor-pointer'
              style={{ backgroundImage: `url(${seekFormImage})` }}
              onClick={() => {
                window.open("https://c.8891.com.tw/buycar/menu/poster", "_blank");
              }}
            ></div>
            <div className='w-[1190px] gap-20'>
              <SeekFormComp
                id={id}
                data={data}
                onPageChange={(data, kindId) => {
                  setInquiryData(data);
                  setKindId(kindId);
                }}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

withLayout({
  cmp: <SeekFormPage />,
  params: {
    needRTBH: false,
    AdTopBanner: true,
    nav: "DefaultFixedNav",
    footer: "Footer",
  },
});
